import { Component, AfterViewInit, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ROUTES } from './menu-items';
import { ROUTES_3 } from './menu-items';
import { ROUTES_4 } from './menu-items';
import { ROUTES_5 } from './menu-items';
import { RouteInfo } from './sidebar.metadata';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';
import { Events } from '../../services/events.service';
declare var $: any;
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html'
})
export class SidebarComponent implements OnInit {
  showMenu = '';
  showSubMenu = '';
  showLocalsMenu = false;
  showAdsMenu = false;
  showRouteMenu = false;
  adminMenu = true;
  hasevents: any;
  hasruta: any;
  isPublicAdmin: any;
  public sidebarnavItems: any[];
  // this is for the open close
  addExpandClass(element: any) {
    if (element === this.showMenu) {
      this.showMenu = '0';
    } else {
      this.showMenu = element;
    }
  }
  addActiveClass(element: any) {
    if (element === this.showSubMenu) {
      this.showSubMenu = '0';
    } else {
      this.showSubMenu = element;
    }
  }

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private auth: AuthenticationService,
    private event: Events,
    private route: ActivatedRoute
  ) {
    this.event.subscribe('checkuser', () => {
      this.checkUser();
    });

  }
  // End open close
  ngOnInit() {
    this.checkUser();

    $(function() {
      $('.sidebartoggler').on('click', function() {
        if ($('#main-wrapper').hasClass('mini-sidebar')) {
          $('body').trigger('resize');
          $('#main-wrapper').removeClass('mini-sidebar');
        } else {
          $('body').trigger('resize');
          $('#main-wrapper').addClass('mini-sidebar');
        }
      });
    });
  }

  checkUser () {
    const user = this.auth.currentUserValue;
    this.adminMenu = true;
    if (user.rol_id !== 1) {
      if (user.rol_id === 8) {
        this.sidebarnavItems = ROUTES_5.filter(sidebarnavItem => sidebarnavItem);
      }
      if (user.rol_id === 3) {
        this.sidebarnavItems = ROUTES_3.filter(sidebarnavItem => sidebarnavItem);
      }
      if (user.rol_id === 4 || user.rol_id === 6) {
        this.adminMenu = false;
        this.sidebarnavItems = ROUTES_4.filter(sidebarnavItem => sidebarnavItem);
      }
    } else {
      this.sidebarnavItems = ROUTES.filter(sidebarnavItem => sidebarnavItem);
    }
    if (user.rol_id === 6) {
      this.isPublicAdmin = true;
    } else {
      this.isPublicAdmin = false;
    }
    if (this.auth.currentUserValue.ruta_id && this.auth.currentUserValue.ruta_id > 0) {
      this.hasruta = 1;
    } else {
      this.hasruta = 0;
    }
    if (this.auth.currentCustomerValue && this.auth.currentCustomerValue.hasevents === 0) {
      this.hasevents = 0;
    } else {
      this.hasevents = 1;
    }
  }

  showItems(item, type) {
    if (type === 1 && item.subvisible === false) {
      this.closeMenu();
    }
    if (item.subvisible) {
      item.subvisible = !item.subvisible;
    } else {
      item.subvisible = true;
    }
  }

  showAds() {
    this.showAdsMenu = !this.showAdsMenu;
  }

  showLocals() {
    this.showLocalsMenu = !this.showLocalsMenu;
  }

  showRoute() {
    this.showRouteMenu = !this.showRouteMenu;
  }

  close() {
    $('.visible').removeClass('visible');
  }

  closeMenu() {
    for (let i = 0; i < this.sidebarnavItems.length; i++) {
      this.sidebarnavItems[i].subvisible = false;
      for (let j = 0; j < this.sidebarnavItems[i].submenu.length; j++) {
        this.sidebarnavItems[i].submenu[j].subvisible = false;
      }
    }
  }
}
